import { Injectable } from '@angular/core';
import {HttpClient} from '@node_modules/@angular/common/http';
import {Observable} from 'rxjs';
import * as AuthReducer from '@store/auth/reducers';
import {Store} from '@node_modules/@ngrx/store';
import * as SpinnerReducer from '@store/spinner/reducers';
import {User} from '@models/user';

@Injectable({
  providedIn: 'root'
})
export class ClassService {

  user: User;

  constructor(
    private httpClient: HttpClient,
    private authStore: Store<AuthReducer.AuthState>,
    private spinnerStore: Store<SpinnerReducer.SpinnerState>
  ) {
    this.authStore.subscribe(
      (val) => {
        const auth = val.auth;
        if (auth && auth.user) {
          this.user = auth.user;
        }
      }
    );
  }

  getAllProgramsClasses(program_id: number) {
    return  this.httpClient.get('class/' + program_id);
  }
  // getAllSchollsClasses() {
  //   if (this.user.activeSchool) {
  //     const school_id = this.user.activeSchool;
  //     return  this.httpClient.get(school_id+'/class');
  //   }
  //   return new Observable();
  // }

  createClass(body) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.post(school_id + '/class' , body);
    }
    return new Observable();
  }
  editClass(body) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.put(school_id + '/class' , body);
    }
    return new Observable();
  }
  addUser(body) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.post(school_id + '/class/user' , body);
    }
    return new Observable();
  }
  inviteUser(body) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.post(school_id + '/class/invite' , body);
    }
    return new Observable();
  }
  getClassesByIds(ids) {
    if (ids.length > 0) {
      ids = ids.join(',');
      return this.httpClient.get('class?ids=' + ids);
    }
    return new Observable();
  }
  getTeachers(ids: Array<number>) {
    if (ids.length > 0) {
      const idsS = ids.join(',');
      return this.httpClient.get('teacher/class?ids=' + idsS);
    }
    return new Observable();
  }
  getUsersClasses(user_id, active = null) {
    let activeQ = '';
    if (active) {
      activeQ += '/active';
    }
    return this.httpClient.get('class/users/' + user_id + activeQ);
  }
}
